import React from "react";
import TaskTextCompleted from "./TaskTextCompleted";
import TaskCheckboxCompleted from "./TaskCheckboxCompleted";
import TaskPassFailCompleted from "./TaskPassFailCompleted";
import { getSubtaskNumberLabel } from "./subtaskNumbering";
import { stepPhotos } from "../tasks_hub/taskHubUtils";

function TaskNameCardCompletedTask(props) {
  const photos = stepPhotos(props.subtask).filter((p) => p.presigned_url);
  if (props.subtask.plan_subtask.type === "heading") {
    return (
      <div className="pt-5 pb-1">
        <p className="text-sm font-bold text-slate-700">
          {props.subtask.plan_subtask.name}
        </p>
        {props.subtask.plan_subtask.description && (
          <p className="text-xs text-slate-400 mt-0.5">
            {props.subtask.plan_subtask.description}
          </p>
        )}
      </div>
    );
  }

  return (
    <div
      className={`py-3.5 ${
        props.index !== props.modalData.plan_subtask_assignments.length - 1
          ? "border-b border-slate-200"
          : ""
      }`}
    >
      <div className="flex gap-3">
        <div className="text-sm font-semibold text-slate-600 w-5 shrink-0 leading-5 tabular-nums">
          {getSubtaskNumberLabel(
            props.modalData?.plan_subtask_assignments,
            props.index,
            (s) => s.plan_subtask?.type
          )}
        </div>
        {props.subtask.plan_subtask.type === "text" ? (
          <div className="min-w-0 flex-1">
            <TaskTextCompleted
              onEdit={props.onEdit}
              subtask={props.subtask}
              isAssignedToEveryone={props.isAssignedToEveryone}
              plan_task_assignment_members={props.plan_task_assignment_members}
            />
          </div>
        ) : props.subtask.plan_subtask.type === "checkbox" ? (
          <div className="min-w-0 flex-1">
            <TaskCheckboxCompleted
              onEdit={props.onEdit}
              subtask={props.subtask}
              isAssignedToEveryone={props.isAssignedToEveryone}
              plan_task_assignment_members={props.plan_task_assignment_members}
            />
          </div>
        ) : props.subtask.plan_subtask.type === "pass_fail" ? (
          <div className="min-w-0 flex-1">
            <TaskPassFailCompleted
              onEdit={props.onEdit}
              subtask={props.subtask}
              isAssignedToEveryone={props.isAssignedToEveryone}
              plan_task_assignment_members={props.plan_task_assignment_members}
            />
          </div>
        ) : null}

      </div>

      <div className="mt-3 ml-8">
        <div className="space-y-2">
          {photos.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {photos.map((photo) => (
                <button
                  type="button"
                  aria-label={`View photo for ${props.subtask.plan_subtask.name}`}
                  key={photo.uuid}
                  onClick={() => {
                    props.setShowLightbox(true);
                    props.setSelectedImage(photo.presigned_url);
                  }}
                  className="cursor-pointer hover:opacity-90 transition-opacity"
                >
                  <img
                    src={photo.presigned_url}
                    alt="Attached"
                    className={`rounded-lg shadow-sm ${
                      photos.length > 1
                        ? "h-[120px] w-[120px] object-cover"
                        : "max-h-[150px] max-w-full w-auto"
                    }`}
                  />
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TaskNameCardCompletedTask;
